module.exports = __webpack_public_path__ + "static/media/icons8-hacking.aa5ee0ec.svg";